// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","dialog__paper":"dialog__paper-1g9Z1"};